import React from "react";
import ListCard from "../../../components/card/ListCard";
import { ROI, SA_Monitoring, Security_Analytics } from "./content";
import coverImage from "../../../utils/images/banner/Success Stories/Img-3.png";

export default function SecurityAnalytics() {
  return (
    <div className="flex justify-center items-center flex-col my-32">
      <div className="text-center">
        <h1 className="text-2xl leading-10">
          <span className="font-semibold">Security</span> Analytics
        </h1>
      </div>
      <img src={coverImage} alt="" className="lg:w-[15%] md:w-[35%] w-[60%] mt-5" />
      {/* imageConatiner */}
      <div></div>
      {/* imageConatiner */}
      <div className="backgroundAbout grid lg:grid-cols-3 grid-cols-1 mt-10 gap-10 py-5 lg:px-32 p-5">
        <ListCard title={"Security Analytics"} list={Security_Analytics} />
        <ListCard title={"SA Monitoring"} list={SA_Monitoring} />
        <ListCard title={"ROI"} list={ROI} />
      </div>
    </div>
  );
}
